<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保报告管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm"
        />
      </div>
    </div>

    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                prop="jhmc"
              >
                <el-input
                  v-model.trim="filterParams.jhmc"
                  class="c-form__input"
                  placeholder="请输入计划名称"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="计划类型"
                prop="jhlx"
              >
                <el-select
                  v-model="filterParams.jhlx"
                  class="c-form__input"
                  placeholder="请选择计划类型"
                  clearable
                >
                  <el-option
                    label="月度"
                    value="YD"
                  />
                  <el-option
                    label="季度"
                    value="JD"
                  />
                  <el-option
                    label="年度"
                    value="ND"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="计划状态"
                prop="jhzt"
              >
                <el-select
                  v-model="filterParams.jhzt"
                  class="c-form__input"
                  placeholder="请选择计划状态"
                  clearable
                >
                  <el-option
                    label="待盖章"
                    value="DGZ"
                  />
                  <el-option
                    label="已完成"
                    value="YWC"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>

    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            ref="reportTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #jhztMc="scope">
              <span>{{ scope.row.jhztMc || '-' }}</span>
            </template>
            <template #bgztMc="scope">
              <span>{{ scope.row.bgztMc || '-' }}</span>
            </template>
            <template #bgbh="scope">
              <el-link
                v-if="scope.row.bgbh"
                type="primary"
                @click="handleDownload(scope.row)"
              >
                {{ scope.row.bgbh }}
              </el-link>
              <span v-else>-</span>
            </template>
            <template #operation="scope">
              <div class="jxxf-report-actions">
                <k-button
                  v-if="scope.row.jhzt === 'DGZ' && scope.row.wgzfjId && !scope.row.gzfjId"
                  btn-text="上传盖章报告"
                  :auth-type="false"
                  type="primary"
                  plain
                  @click="openUpload(scope.row)"
                />
                <k-button
                  v-if="scope.row.jhzt === 'DGZ' && scope.row.wgzfjId && !scope.row.gzfjId"
                  btn-text="申请修改"
                  :auth-type="false"
                  type="warning"
                  plain
                  @click="handleModification(scope.row)"
                />
                <span
                  v-if="scope.row.jhzt !== 'DGZ' || !scope.row.wgzfjId || scope.row.gzfjId"
                  class="jxxf-report-actions__empty"
                >
                  -
                </span>
              </div>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="上传签字盖章报告"
      :visible.sync="uploadDialogVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetUploadDialog"
    >
      <el-form label-width="100px">
        <el-form-item label="报告文件">
          <file-serve-upload
            ref="sealedReportUpload"
            v-model="uploadFileId"
            :file-api="$config.ctx.hmfileApi"
            show-file-list
            accept="application/pdf,.pdf"
            :format="['pdf', 'PDF']"
            :data="uploadFd"
            :max-size="30 * 1024"
          >
            <k-button
              btn-text="选择PDF文件"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-cloud-upload"
              plain
            />
          </file-serve-upload>
          <span class="u-text-warning">（仅支持 PDF，最大 30M）</span>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          :loading="uploadSubmitting"
          :disabled="!uploadFileId"
          @click="submitUpload"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          :disabled="uploadSubmitting"
          @click="uploadDialogVisible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reportService } from './report.service';

export default {
  name: 'JxxfWbReportList',
  data () {
    return {
      loading: false,
      uploadDialogVisible: false,
      uploadFileId: null,
      uploadRow: null,
      uploadSubmitting: false,
      uploadFd: { meta: [{ key: 'jxxf_wb_sealed_report', value: 'Y' }] },
      filterParams: {
        xmmc: null,
        jhmc: null,
        jhlx: null,
        jhzt: null
      },
      trueFilterParams: {},
      page: { rows: [], total: 0, pageSize: 15, pageNo: 0 },
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'jhmc', label: '计划名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'jhlxMc', label: '计划类型', align: 'center', width: '90', type: 'text' },
        { key: 'qhbh', label: '期号', align: 'center', width: '100', type: 'text' },
        { key: 'jhsjQ', label: '执行开始', align: 'center', minWidth: '110', type: 'date' },
        { key: 'jhsjZ', label: '执行结束', align: 'center', minWidth: '110', type: 'date' },
        { key: 'jhztMc', slotName: 'jhztMc', label: '计划状态', align: 'center', minWidth: '100', type: 'text' },
        { key: 'bgztMc', slotName: 'bgztMc', label: '报告状态', align: 'center', minWidth: '100', type: 'text' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'center', minWidth: '150', type: 'text' },
        { key: 'operation', slotName: 'operation', label: '操作', align: 'center', minWidth: '250', type: 'text' }
      ]
    };
  },
  methods: {
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    search (pageNo = 1) {
      const params = Object.assign({}, this.trueFilterParams, {
        pageNo,
        pageSize: this.page.pageSize
      });
      this.loading = true;
      reportService.page(params).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    resetForm () {
      this.$refs.filterParams.resetFields();
      this.refreshSearch();
    },
    /** 打开最终盖章报告上传弹窗。 */
    openUpload (row) {
      this.uploadRow = row;
      this.uploadFileId = null;
      this.uploadSubmitting = false;
      this.uploadDialogVisible = true;
    },
    resetUploadDialog () {
      if (this.$refs.sealedReportUpload) this.$refs.sealedReportUpload.clearFiles();
      this.uploadDialogVisible = false;
      this.uploadFileId = null;
      this.uploadRow = null;
      this.uploadSubmitting = false;
    },
    submitUpload () {
      if (!this.uploadRow || !this.uploadFileId) {
        this.$message.warning('请先选择签字盖章报告文件');
        return;
      }
      this.uploadSubmitting = true;
      reportService.uploadSealedReport(this.uploadRow.jhId, { fileId: this.uploadFileId }).then(rsp => {
        const result = rsp.data && rsp.data.data;
        this.$message.success(result && result.message ? result.message : '签字盖章报告上传成功');
        this.uploadDialogVisible = false;
        this.search(this.page.pageNo || 1);
      }).catch(() => {}).finally(() => {
        this.uploadSubmitting = false;
      });
    },
    /** 报告管理仅允许撤回未盖章报告；预览和正式生成在计划详情页执行。 */
    handleModification (row) {
      this.$prompt('请输入申请修改原因', '申请修改', {
        inputPlaceholder: '请输入申请修改原因',
        inputValidator: value => value && value.trim() ? true : '申请修改原因不能为空',
        inputErrorMessage: '申请修改原因不能为空'
      }).then(({ value }) => {
        return reportService.requestModification(row.jhId, { reason: value }).then(rsp => {
          const result = rsp.data && rsp.data.data;
          this.$message.success(result && result.message ? result.message : '报告已撤回');
          this.search(this.page.pageNo || 1);
        });
      }).catch(() => {});
    },
    downloadByFileId (fileId, fileName) {
      return this.$axios.get(`${this.$config.fileApi.initDownload}/${fileId}`).then(rsp => {
        const filePath = rsp.data && rsp.data.data;
        if (!filePath) throw new Error('报告文件路径为空');
        return this.$axios.get(`${this.$config.fileApi.download}/${filePath}`, { responseType: 'blob' });
      }).then(res => {
        this.$HMUtil.downloadStreamFile(res.data, fileName);
      });
    },
    handleDownload (row) {
      const fileId = row.gzfjId || row.wgzfjId;
      if (!fileId) {
        this.$message.warning('该报告暂无可下载文件');
        return;
      }
      this.downloadByFileId(fileId, `${row.bgbh || '维保报告'}.pdf`).catch(() => {
        this.$message.error('报告下载失败');
      });
    }
  },
  created () {
    this.refreshSearch();
  }
};
</script>

<style scoped lang="scss">
.jxxf-report-actions {
  display: flex;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.jxxf-report-actions__empty {
  color: #909399;
}
</style>
